'use strict';

var escapeXmlAttr = require('raptor-util/escapeXml').attr;

module.exports = function formatPh(element, data, context) {
    var options = element.options || {};
    var value = data[element.name];
    if (value === undefined) {
        throw new Error('Cannot find value for placeholder ' + element.name);
    }
    if (element.type) {
        var formatterKey = 'ph:' + element.type;
        var format = context.formatters && (context.formatters[formatterKey] || context.formatters[element.type]);
        if (!format) {
            throw new Error('Cannot find formatter for placeholder ' + element.name + ' with formatter ' + formatterKey);
        }
        value = format(element, value, context);
    }
    // NOTE: Dynamic data might have user input that needs to be escaped.
    //       escapeXmlAttr escapes the following chars: &<>"'\n
    return options.escape === false ? value  : escapeXmlAttr(value);
};
